// Simple SVG avatar as data URL
export const DEFAULT_AVATAR_DATA_URL = `data:image/svg+xml;base64,${btoa(`
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="20" cy="20" r="20" fill="#e2e8f0"/>
  <circle cx="20" cy="16" r="6" fill="#94a3b8"/>
  <path d="M8 32c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#94a3b8"/>
</svg>
`)}`;

// Generate avatar from username initials
export const generateInitialsAvatar = (username: string): string => {
  const initials = username
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
  
  // Simple color based on username hash
  const colors = ['#667eea', '#764ba2', '#f093fb', '#4facfe', '#43e97b', '#fa709a'];
  const colorIndex = username.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  const bgColor = colors[colorIndex];
  
  return `data:image/svg+xml;base64,${btoa(`
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="20" cy="20" r="20" fill="${bgColor}"/>
  <text x="20" y="26" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="14" font-weight="600">${initials}</text>
</svg>
  `)}`;
};

// Get appropriate avatar URL with fallbacks
export const getAvatarUrl = (avatarUrl?: string, username?: string): string => {
  if (avatarUrl) {
    return avatarUrl;
  }
  
  if (username) {
    return generateInitialsAvatar(username);
  }
  
  return DEFAULT_AVATAR_DATA_URL;
};